import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Pasar horas cada semana planificando clases desde cero para diferentes niveles.', 'Quedarte sin ideas y repetir siempre los mismos ejercicios aburridos.', 'Luchar por mantener a los alumnos motivados y participando.', 'Sentir esa presión de caminar al patio sin un plan claro y profesional.'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-182" data-mp="39gup0gpqnaq9">
      <div className="mx-auto max-w-4xl text-center" data-id="element-183" data-mp="39jqo48dbo5ga">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-184" data-mp="35fiv3yzu03c9">
          La realidad de enseñar hoy
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-185" data-mp="3jdzb6gjl3672">
          Si das clases de Educación Física, probablemente te enfrentas a esto:
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-186" data-mp="1p456myqzzdci">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-5" data-id="element-187" data-mp="1k5al3p1nbaop">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-188" data-mp="obezd49sgwca" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-189" data-mp="se1rl6adgja0">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-emerald-300 sm:text-4xl" data-id="element-190" data-mp="x5td32eo7yta">
          ¿Cuántas clases más quieres seguir improvisando?
        </p>
      </div>
    </section>;
}